/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnteDTO } from './EnteDTO';
import {
    EnteDTOFromJSON,
    EnteDTOFromJSONTyped,
    EnteDTOToJSON,
} from './EnteDTO';
import type { AssistitoDTO } from './AssistitoDTO';
import {
    AssistitoDTOFromJSON,
    AssistitoDTOFromJSONTyped,
    AssistitoDTOToJSON,
} from './AssistitoDTO';

/**
 * 
 * @export
 * @interface EmergenzaAssistitoDTO
 */
export interface EmergenzaAssistitoDTO {
    /**
     * 
     * @type {string}
     * @memberof EmergenzaAssistitoDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof EmergenzaAssistitoDTO
     */
    emergenzaId?: string;
    /**
     * 
     * @type {Date}
     * @memberof EmergenzaAssistitoDTO
     */
    assegnatoIl?: Date;
    /**
     * 
     * @type {AssistitoDTO}
     * @memberof EmergenzaAssistitoDTO
     */
    assistito?: AssistitoDTO;
    /**
     * 
     * @type {EnteDTO}
     * @memberof EmergenzaAssistitoDTO
     */
    ente?: EnteDTO;
    /**
     * 
     * @type {string}
     * @memberof EmergenzaAssistitoDTO
     */
    motivoMancataAllocazione?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EmergenzaAssistitoDTO
     */
    assistenza?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof EmergenzaAssistitoDTO
     */
    assistenzaData?: Date;
    /**
     * 
     * @type {string}
     * @memberof EmergenzaAssistitoDTO
     */
    puntoDiRaccoltaId?: string;
    /**
     * 
     * @type {string}
     * @memberof EmergenzaAssistitoDTO
     */
    altroLuogo?: string;
    /**
     * 
     * @type {string}
     * @memberof EmergenzaAssistitoDTO
     */
    noteRifiuto?: string;
}

/**
 * Check if a given object implements the EmergenzaAssistitoDTO interface.
 */
export function instanceOfEmergenzaAssistitoDTO(value: object): value is EmergenzaAssistitoDTO {
    return true;
}

export function EmergenzaAssistitoDTOFromJSON(json: any): EmergenzaAssistitoDTO {
    return EmergenzaAssistitoDTOFromJSONTyped(json, false);
}

export function EmergenzaAssistitoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergenzaAssistitoDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'emergenzaId': json['emergenzaId'] == null ? undefined : json['emergenzaId'],
        'assegnatoIl': json['assegnatoIl'] == null ? undefined : (new Date(json['assegnatoIl'])),
        'assistito': json['assistito'] == null ? undefined : AssistitoDTOFromJSON(json['assistito']),
        'ente': json['ente'] == null ? undefined : EnteDTOFromJSON(json['ente']),
        'motivoMancataAllocazione': json['motivoMancataAllocazione'] == null ? undefined : json['motivoMancataAllocazione'],
        'assistenza': json['assistenza'] == null ? undefined : json['assistenza'],
        'assistenzaData': json['assistenzaData'] == null ? undefined : (new Date(json['assistenzaData'])),
        'puntoDiRaccoltaId': json['puntoDiRaccoltaId'] == null ? undefined : json['puntoDiRaccoltaId'],
        'altroLuogo': json['altroLuogo'] == null ? undefined : json['altroLuogo'],
        'noteRifiuto': json['noteRifiuto'] == null ? undefined : json['noteRifiuto'],
    };
}

export function EmergenzaAssistitoDTOToJSON(value?: EmergenzaAssistitoDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'emergenzaId': value['emergenzaId'],
        'assegnatoIl': value['assegnatoIl'] == null ? undefined : ((value['assegnatoIl']).toISOString()),
        'assistito': AssistitoDTOToJSON(value['assistito']),
        'ente': EnteDTOToJSON(value['ente']),
        'motivoMancataAllocazione': value['motivoMancataAllocazione'],
        'assistenza': value['assistenza'],
        'assistenzaData': value['assistenzaData'] == null ? undefined : ((value['assistenzaData'] as any).toISOString()),
        'puntoDiRaccoltaId': value['puntoDiRaccoltaId'],
        'altroLuogo': value['altroLuogo'],
        'noteRifiuto': value['noteRifiuto'],
    };
}

